import { type NavigationAdapter } from './NavigationAdapter';
import { usePlatform } from '../PlatformContext';

export const useNavigation = (): NavigationAdapter => usePlatform().navigation;
